<script>
export default {
  name: 'XButtonGroupItem',
  functional: true,
  render (createElement, context) {
    return context.props.item.render(createElement, context.props, context);
  }
};
</script>
